var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3IconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10V0H16L10.5763 5.11111L15.7535 10H0Z",
    fill: "#CACACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.924V3H5.364V3.588H3.696V4.59H5.106V5.178H3.696V6.336H5.424V6.924H3Z",
    fill: "#1E1E2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17052 6.996C6.86252 6.996 6.60252 6.944 6.39052 6.84C6.18252 6.732 6.01052 6.604 5.87452 6.456L6.20452 6.012C6.32052 6.128 6.45252 6.228 6.60052 6.312C6.74852 6.392 6.91852 6.432 7.11052 6.432C7.31852 6.432 7.48652 6.382 7.61452 6.282C7.74652 6.178 7.81252 6.036 7.81252 5.856C7.81252 5.724 7.77852 5.61 7.71052 5.514C7.64652 5.414 7.53252 5.338 7.36852 5.286C7.20852 5.234 6.98252 5.208 6.69052 5.208V4.704C7.06652 4.704 7.32652 4.646 7.47052 4.53C7.61452 4.414 7.68652 4.268 7.68652 4.092C7.68652 3.932 7.63652 3.808 7.53652 3.72C7.43652 3.628 7.29852 3.582 7.12252 3.582C6.97452 3.582 6.83852 3.616 6.71452 3.684C6.59052 3.748 6.47052 3.834 6.35452 3.942L6.00052 3.516C6.16452 3.372 6.33852 3.256 6.52252 3.168C6.71052 3.08 6.91852 3.036 7.14652 3.036C7.51452 3.036 7.81252 3.124 8.04052 3.3C8.26852 3.472 8.38252 3.72 8.38252 4.044C8.38252 4.256 8.32252 4.436 8.20252 4.584C8.08652 4.728 7.92452 4.84 7.71652 4.92V4.944C7.94052 5.004 8.12852 5.114 8.28052 5.274C8.43252 5.434 8.50852 5.64 8.50852 5.892C8.50852 6.124 8.44652 6.322 8.32252 6.486C8.20252 6.65 8.04052 6.776 7.83652 6.864C7.63652 6.952 7.41452 6.996 7.17052 6.996Z",
    fill: "#1E1E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE3IconMenu);
export default __webpack_public_path__ + "static/media/e3-icon-menu.69332f93d7933fd15b618cc57efb1ae1.svg";
export { ForwardRef as ReactComponent };